// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kCav","right":"styles_right__5D8YB"};